import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../services/app.service';
import { environment } from '../../environment/environment';
import { MsalService } from '@azure/msal-angular';
import { DataService } from '../services/data.service';
import { catchError, switchMap } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { SharedService } from '../services/shared.service';
import { Notification, NotificationComponent } from '../notification/notification.component';
import { TranslatePipe } from '@ngx-translate/core';
@Component({
  selector: 'app-header',
  imports: [CommonModule, NotificationComponent, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  isProgress = true;
  lastLoginDateTime: string = '';
  notification: Notification = {
    label: '',
    description: '',
    type: ''
  };
  constructor(
    public apiService: ApiService,
    private msalService: MsalService,
    private router: Router,
    public dataservice: DataService,
    private sharedService: SharedService
  ) {}
  onLogoutClick = async () => {
    try {
      sessionStorage.removeItem('lastLoginSaved');
      // Ensure MSAL instance is initialized before calling any MSAL APIs
      await this.msalService.instance.initialize();

      this.msalService.logoutRedirect({
        postLogoutRedirectUri:
          environment.authClientConfiguration.logout_return_to_url,
      });
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  ngOnInit(): void {
    this.loadUserProfileAndPicture();
  }

  private loadUserProfileAndPicture(): void {
    this.apiService
      .getUserProfile()
      .pipe(
        switchMap((profile) => {
          this.dataservice.profile = {
            ...this.dataservice.profile,
            ...profile
          };
          const userDetailPayload = {
            Department: profile.department,
            Country: profile.country,
            EmailId: profile.mail
          };

          this.apiService.saveUserDetails(userDetailPayload).pipe(
            catchError((err) => {
              console.error('Saving user details failed:', err);
              return of(null);
            })
          ).subscribe();
          
          return forkJoin([
            this.apiService.userProfilePicture$,
            this.apiService.getLastLogin().pipe(
              catchError((err) => {
                console.error('Fetching last login failed:', err);
                return of(null);
              })
            )
          ]);
        })
      )
      .subscribe({
        next: ([profilePicUrl, lastLoginResponse]) => {
          this.dataservice.profile.photo = profilePicUrl;

          if (lastLoginResponse?.lastLoginDateTime) {
            const utcDate = lastLoginResponse.lastLoginDateTime.endsWith('Z')
              ? lastLoginResponse.lastLoginDateTime
              : lastLoginResponse.lastLoginDateTime + 'Z';
            this.lastLoginDateTime = new Date(utcDate).toLocaleString();
            this.dataservice.profile.lastLoginDateTime = this.lastLoginDateTime;
          }

          // Save the current login time only once per session
          if (!sessionStorage.getItem('lastLoginSaved')) {
            const currentLoginDateTime = new Date().toISOString();
            this.apiService.saveLastLogin(currentLoginDateTime).pipe(
              catchError((err) => {
                console.error('Saving last login failed:', err);
                return of(null);
              })
            ).subscribe(() => {
              sessionStorage.setItem('lastLoginSaved', 'true');
            });
          }
        },
        error: (error) => {
          console.error('Error fetching user profile or picture:', error);
          this.isProgress = false;
        },
      });
  }
  onLogoClick(): void {
   if (this.sharedService.checkHasChanges()) {
    this.sharedService.triggerUnsavedChangesForNavigation('/');
  } else {
    this.router.navigate(['/']);
    this.sharedService.resetTestRun();
  }
  }

  isLoginPage(): boolean {
    return this.router.url === '/login';
  }

  onReadmeOssClick(): void {
  window.open('assets/readme_oss.html', '_blank'); 
}
onUserManualClick(): void {
  window.open('assets/user_manual.html', '_blank');
}

}
